/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

export const NextPodcastWrapper = styled.div`
  background: var(--white);
  border: 1px solid var(--grey-3);
  box-shadow: 0px 15px 40px rgba(11, 26, 33, 0.1);
  border-radius: 8px;

  .next-podcast--container {
    .next-podcast--header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid var(--grey-4);
      padding: 20px 25px 14px;

      .next-podcast--header-title {
        font-weight: var(--font-weight-700);
        font-size: var(--font-size-20);
        line-height: var(--line-height-120);
        letter-spacing: var(--letter-spacing--0-01);
        margin: 0;
      }
    }

    .next-podcast--body {
      margin: 10px;
      padding: 10px 15px;
      background: var(--white);
      border-radius: 8px;

      &:hover {
        background: var(--titan-blue-1);
      }

      a {
        display: flex;
      }

      .next-podcast--image-container {
        width: 90px;
        height: 90px;

        .next-podcast--image {
          max-width: 100%;
        }
      }

      .next-podcast--text-container {
        flex: 1;
        padding: 6px 10px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .next-podcast--title {
          font-weight: var(--font-weight-700);
          font-size: var(--font-size-16);
          line-height: var(--line-height-150);
          margin: 0;
          height: 48px;
          overflow: hidden;
        }

        .next-podcast--text-sub-container {
          display: flex;
          align-items: center;
          justify-content: space-between;

          .next-podcast--text-duration {
            font-weight: var(--font-weight-500);
            font-size: var(--font-size-13);
            line-height: var(--line-height-150);
            color: var(--dark);
            margin: 0;
          }
        }
      }
    }

    .next-podcast--footer {
      padding: 20px 25px;
      border-top: 1px solid var(--grey-3);

      .next-podcast--footer-title {
        font-weight: var(--font-weight-700);
        font-size: var(--font-size-16);
        line-height: var(--line-height-150);
        margin-bottom: 0;
      }

      .next-podcast--others {
        display: flex;
        flex-wrap: wrap;

        .next-podcast--others-item {
          display: block;
          margin-right: 30px;
          margin-top: 10px;

          .next-podcast--others-item-img {
            width: 40px;
            height: 40px;
          }
        }
      }
    }
  }
`;
